import { ProgressCircle } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Size } from '~/types/ThemeTypes'

interface LoadingSpinnerProps {
  size?: Size.sm | Size.md | Size.lg
}
export const LoadingSpinner = ({ size = Size.md }: LoadingSpinnerProps) => {
  const { t } = useTranslation()
  return (
    <ProgressCircle.Root
      value={null}
      size={size}
      translations={{ value: () => t('loadingSpinner.label', 'Loading') }}
    >
      <ProgressCircle.Circle>
        <ProgressCircle.Track stroke="bg.emphasized" />
        <ProgressCircle.Range stroke="brand.solid" />
      </ProgressCircle.Circle>
    </ProgressCircle.Root>
  )
}
